module.exports = __webpack_public_path__ + "img/quiet_Scene2.3cb32ec5.gif";